import MaterialReactTable from "material-react-table";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useState  } from "react";
import { allAnnonceType, annonceDeleted } from "../../../Redux/annonceReduce";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-multi-lang';
import { toast, ToastContainer } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import { verification } from "../../../Redux/usersReduce";
import Configuration from "../../../configuration";
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";

// core components
function ListNew({client}) {
  let lang = window.localStorage.getItem("lang");
  const t = useTranslation();
  document.title = t("New.list");
  const dispatch = useDispatch();
  const navigate = useHistory();
  var annee = localStorage.getItem("annee");
  const [alert, setAlert] = React.useState(null);
  const [entities, setEntities] = React.useState([]);
  const [loader, setLoader] = useState(true);
  const notify = (type, msg) => {
    if (type === 1)
      toast.success(
        <strong>

          {msg}
        </strong>
      );
    else
      toast.error(
        <strong>

          {msg}
        </strong>
      );
  };
  function ajouter() {
    navigate.push(client+'/ajouterNew');
  }

  const [columns] = React.useState(
    [{
      header: t("image"),
      accessorKey: "image",
      Cell: ({ cell }) => (
        cell.row.original.image != "" && cell.row.original.image != null ? <img className="image-product" src={Configuration.BACK_BASEURL + "annonce/" + cell.row.original.image}
        ></img> : null
      )
    },
    {
      header: t("designation"),
      accessorKey: "titre",
    },
    {
      header: t("code_pct"),
      accessorKey: "code_pct",
    },
    {
      header: t("code_article"),
      accessorKey: "code_article",
    },
    {
      header: t("prix"),
      accessorKey: "prix",
    },
    {
      header: t("actions"),
      accessorKey: "id",
      Cell: ({ cell }) => (
        <div className="actions-right block_action">
          <Button
            onClick={() => {
              navigate.push(client+"/new/update/" + cell.row.original.id);
            }}
            variant="warning"
            size="sm"
            className="text-warning btn-link edit"
          >
            <i className="fa fa-edit" />
          </Button>
          <Button
            id={"idLigne_" + cell.row.original.id}
            onClick={(e) => {
              confirmMessage(cell.row.original.id, cell.row.id);
            }}
            variant="danger"
            size="sm"
            className="text-danger btn-link delete"
          >
            <i className="fa fa-trash" id={"idLigne_" + cell.row.original.id} />
          </Button>
        </div>
      ),
    },
    ]
  );
  const hideAlert = () => {
    setAlert(null);
  };
  function ListTable({ list, loader }) {
    return (
      <MaterialReactTable
        state={{ isLoading: loader }}
        columns={columns}
        data={list}
        enableColumnActions={true}
        enableColumnFilters={true}
        enablePagination={true}
        enableSorting={true}
        enableBottomToolbar={true}
        enableTopToolbar={true}
        muiTableBodyRowProps={{ hover: false }}
        displayColumnDefOptions={{
          'mrt-row-numbers': {
            size: 10,
          },
          'mrt-row-expand': {
            size: 10,
          },
        }}
        enableColumnFilterModes
        initialState={{
          columnVisibility: { description: false },
          density: 'compact',
          showGlobalFilter: true,
        }}
        muiSearchTextFieldProps={{
          placeholder: t("search"),
          sx: { minWidth: '18rem' },
          variant: 'outlined',
        }}

        filterFns={{
          myCustomFilterFn: (row, id, filterValue) => {
            const value = row.getValue(id);
            return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
          },
        }}
        globalFilterFn="myCustomFilterFn"

        localization={
          lang === "fr"
            ? MRT_Localization_FR
            : MRT_Localization_EN
        }

      />
    );
  }

  const confirmMessage = (id, e) => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title={"Êtes-vous sûr de vouloir continuer ? "}
        onConfirm={() => deleteA(id, e)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        cancelBtnBsStyle="danger"
        confirmBtnText="Oui"
        cancelBtnText="Non"
        showCancel
      >
     
      </SweetAlert>
    );
  };

  const getNew = useCallback(async (titre) => {
    var news = await dispatch(allAnnonceType({ type: 2, annee: annee ,client}));
    setEntities(news.payload);
    setLoader(false)
  }, [dispatch]);

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  const deleteA = useCallback(async (id, e) => {
    try {
      hideAlert();
      var test = await dispatch(annonceDeleted({ id }));
      if (test.payload) {
        notify(1, t("supprimer_succes"));
        await getNew();
      }
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'annonce:', error);
    }

  }, [dispatch, getNew]);

  useEffect(() => {
    verifToken()
    getNew()
  }, [getNew]) //now shut up eslint
  return (
    <>
      <Container fluid>
        <ToastContainer />
        {alert}
        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-info mr-1 float-left"
              type="button"
              onClick={ajouter}
            >
              <span className="btn-label">
                <i className="fas fa-plus"></i>
              </span>
              {t("New.add")}
            </Button>
          </Col>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4"> {t("New.list")}</Card.Title>
              </Card.Header>
              <Card.Body className="padding-0">
                <ListTable list={entities} loader={loader} ></ListTable>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListNew;
